<br><br><br><br>
<div class="page-title">
    <h1 class="title-text">Training Request</h1>
    <p class="form-desc"></p>
</div>
<br>

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="create()">
        <br>
        <mat-form-field appearance="fill">
            <mat-label>Email:</mat-label>
            <input matInput formControlName="email" placeholder="Enter valid email:" required>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Type of training:</mat-label>
            <input matInput formControlName="type" placeholder="Describe the type of training required:" required>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Training justification/reason:</mat-label>
            <input matInput formControlName="reason" placeholder="List reason(s) training is needed:" required>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Training date needed by:</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Estimated Cost (if unknown, leave blank):</mat-label>
            <input matInput formControlName="cost" placeholder="Enter estimated cost of trianing:">
        </mat-form-field>

        <mat-label class="qTitle">Online Training:</mat-label>
        <br><br>
        <mat-radio-group formControlName="online" name="online" required>
          <mat-radio-button value="yes">Yes</mat-radio-button>
          <mat-radio-button value="no">No</mat-radio-button>
          <mat-radio-button value="unknown">Unknown</mat-radio-button>
        </mat-radio-group>
        <br><br>

        <mat-form-field appearance="fill">
            <mat-label>If not online, please specify training location: </mat-label>
            <input matInput formControlName="desc" placeholder="Enter training location:">
        </mat-form-field>

        <div class="button-container">
            <button mat-raised-button color="primary" class="submit-button">Submit</button>
        </div>
      </form>
    </mat-card-content>
</mat-card>
